<template>
  <div
    class="next-auctions-card"
    :class="{ 'no-inner-width': noInnerWidth }"
    :style="{
      border: border,
    }"
    @click="$emit('click')"
  >
    <v-img
      v-if="card.assets && card.assets.feature"
      :max-width="maxImgWidth || '430px'"
      :max-height="maxImgHeight || '275px'"
      :src="`${card.assets.feature.filename}`"
    ></v-img>
    <div class="next-auctions-card__content">
      <span class="next-auctions-card__title">{{ card.name }}</span>
      <p class="next-auctions-card__description">
        {{ card.description }}
      </p>
      <div class="next-auctions-card__timer">
        <VueCountdownTimer
          :start-time="getHoursStart"
          :end-time="getHoursEnd"
          :interval="1000"
          :end-text="'Evento finalizado!'"
          @start_callback="startCallBack('event started')"
          @end_callback="endCallBack('event ended')"
        >
          <template
            slot="countdown"
            slot-scope="scope"
          >
            <div>
              <span v-if="scope.props.days != '00'">
                {{ scope.props.days }} <span class="label">dias</span>
              </span>
              <span>{{ scope.props.hours }} <span class="label">hrs</span></span>
              <span>{{ scope.props.minutes }} <span class="label">min</span></span>
              <span>{{ scope.props.seconds }}<span class="label">seg</span></span>
            </div>
          </template>
        </VueCountdownTimer>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'UpcomingAuctionsCard',
  props: {
    card: {
      type: Object,
      default: () => {},
      require: true,
    },
    maxImgWidth: {
      type: String,
      default: () => '',
    },
    maxImgHeight: {
      type: String,
      default: () => '',
    },
    border: {
      type: String,
      default: () => 'none',
    },
    noInnerWidth: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      day: Math.ceil(Math.random() * 10),
    };
  },
  computed: {
    getHoursStart() {
      return moment().add(this.day, 'day');
    },
    getHoursEnd() {
      return moment().add(this.day + 1, 'day');
    },
  },
  methods: {
    startCallBack() {},
    endCallBack() {},
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.next-auctions-card {
  background-color: #ffffff;
  cursor: pointer;
  scroll-snap-align: start;
  min-width: 350px;

  &.no-inner-width {
    max-width: initial;
  }

  &__content {
    padding: 64px;
    position: relative;
    @media (max-width: $lg) {
      padding: 20px;
    }
  }

  &__title {
    letter-spacing: -0.015em;
    font-weight: 700;
    margin-bottom: 25px;
    font-size: 24px;
    color: #000000;
    display: block;

    @media (max-width: $lg) {
      line-height: 20px;
      font-size: 18px;
    }
  }

  &__description {
    font-size: 18px;
    letter-spacing: -0.015em;
    color: rgba(0, 0, 0, 0.8);
    @media (max-width: $lg) {
      font-size: 14px;
    }
  }

  &__timer {
    width: 315px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ee396c;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    border-radius: 6px;
    div {
      display: flex;
      align-items: center;
      font-size: 17px;
      line-height: 21px;
      letter-spacing: -0.015em;
      color: #ffffff;
      font-weight: 500;

      span {
        display: flex;
        flex-direction: column;
        padding: 0 10px;
        text-align: center;
        position: relative;

        &:not(:last-child) {
          &:after {
            content: ':';
            position: absolute;
            top: 12px;
            right: 0;
            transform: translate(-50%, -50%);
          }
        }
      }
      .label {
        font-size: 12px;
      }
    }
  }
}
</style>
